module.exports = __webpack_public_path__ + "img/6.d26af56f.jpg";